import {Component, inject} from '@angular/core';
import {DialogRef} from '@angular/cdk/dialog';
import {UiEpgButtonDirective} from '@epg-apps/ui-button';

@Component({
  selector: 'cdh-cdh-download-initial-dialog',
  imports: [UiEpgButtonDirective],
  templateUrl: './cdh-download-initial-dialog.component.html',
  styleUrl: './cdh-download-initial-dialog.component.scss',
})
export class CdhDownloadInitialDialogComponent {
  private dialogRef = inject(DialogRef);

  close() {
    this.dialogRef.close();
  }
}
